<template>
  <div class="flex justify-center items-center">
    <div class="w-1/2 flex h-screen bg-blue justify-center items-center">
      <h1 class="text-3xl font-semibold text-blue-lightest"> Doctor Dashboard </h1>
    </div>
    <form v-if="isCredentialsTypeValid" class="w-1/2 flex flex-col h-screen justify-center items-center" v-on:submit="submit()">
      <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div @click="goBack" class="cursor-pointer text-sm italic mb-6 text-grey-dark hover:text-blue hover:font-semibold">
          <i class="fas fa-arrow-left"></i> Back
        </div>
        <div class="mb-6">
          <label class="block text-grey-darker text-base font-semibold mb-4">
            Enter OTP
          </label>
          <p class="text-base text-grey-dark mb-8">OTP has been sent to your registered e-mail</p>
          <label class="block text-grey-darker text-sm font-semibold mb-2">
            OTP
          </label>
          <input class="shadow appearance-none border rounded w-full py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline" id="otp" type="text" placeholder="Code" v-model="mfa.otp_code" 
            value=""
            maxlength="10"
            :has-counter="false">
        </div>
        <div class="flex items-center justify-between mt-4">
          <button type="submit" class="bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
            Submit
          </button>
          <div @click="resendOTP" class="cursor-pointer text-sm italic text-grey-dark hover:text-blue hover:font-semibold">
            <a href="#">Resend OTP</a>
          </div>
        </div>
      </div>
    </form>
    <form v-else class="w-1/2 flex flex-col h-screen justify-center items-center" v-on:submit="submit()">
      <div class="bg-white shadow-md rounded px-16 w-96 pt-6 pb-8 mb-4">
        <div @click="goBack" class="cursor-pointer text-sm italic mb-6 text-grey-dark hover:text-blue hover:font-semibold">
          <i class="fas fa-arrow-left"></i> Back
        </div>
        <div class="mb-6">
          <label class="block text-grey-darker text-base font-semibold mb-4">
            Multi-factor Authentication
          </label>
          <p class="text-base text-grey-dark mb-8">Enter an MFA code to login</p>
          <label class="block text-grey-darker text-sm font-semibold mb-2">
            MFA Code
          </label>
          <input class="shadow appearance-none border rounded w-full py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline" id="otp" type="text" placeholder="Code" v-model="mfa.otp_code" 
            value=""
            maxlength="10"
            :has-counter="false">
        </div>
        <div class="flex items-center justify-between mt-4">
          <button type="submit" class="bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
            Connect
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import router from '../../router'
import Raven from 'raven-js'
import {mapState} from 'vuex'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import Vue from 'vue'
import localforage from 'localforage'

Vue.use(VueToast)
export default {
  data () {
    return {
      mfa: {
        type: true,
        enabled: false,
        otp_code: ''
      },
      credentials: {
        username: '',
        password: '',
        type: ''
      },
      error: false,
      showAlreadyLogged: false,
      showLogin: true,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      role: state => state.configuration.role
    }),
    isCredentialsTypeValid () {
      return this.mfa.type
    }
  },
  methods: {
    submit () {
      event.preventDefault()
      var credentials = {
        email: this.credentials.username,
        password: this.credentials.password,
        otp_code: this.mfa.otp_code
      }
      this.isLoading = true
      this.$http.post(window.API_URL + 'online_doctors/sign_in', credentials).then(response => {
        if (response.status === 200) {
          if (response.headers.get('X-DOCTOR-KEY')) {
            Raven.setUserContext({name: response.body.doctor.name, id: response.body.doctor.doctor_id})
            sessionStorage.setItem('X-DOCTOR-KEY', response.headers.get('X-DOCTOR-KEY'))
            sessionStorage.setItem('availableForChat', false)
            sessionStorage.setItem('isLoggedIn', true)
            sessionStorage.removeItem('mfa_token')
            this.$store.dispatch('configuration/init')
            if (response.body.doctor.role === 'admin') {
              sessionStorage.setItem('isAdmin', true)
              router.push('admin-home')
            } else {
              router.push('home')
            }
            this.clearLocalForage()
          } else if (response.body.message === 'Invalid OTP code') {
            alert('Invalid OTP code')
            return
          } else if (response.body.message === 'account locked') {
            alert('Your account has been locked, please try after 24 hours.')
            router.push('login')
          } else {
            alert('No access token found')
            return
          }
        }
      }).catch(error => {
        this.isLoading = false
        this.$toast.open({
          message: error.body.message || 'something went wrong!',
          type: 'error',
          position: 'top',
          queue: false
        })
      })
    },
    goBack: function () {
      this.$router.go(-1)
    },
    resendOTP: function () {
      this.isLoading = true
      var options = { email: this.credentials.username }
      this.$http.post(window.API_URL + 'doctors/mfa_settings/resend_otp', options).then(response => {
        if (response.status === 200) {
          this.isLoading = false
          this.$toast.open({
            message: response.body.message,
            type: 'success',
            position: 'top',
            queue: false
          })
        }
      }).catch(function () {
        this.isLoading = false
        this.enableViaOtp = false
        this.$toast.open({
          message: 'MFA token expired!',
          type: 'error',
          position: 'top',
          queue: false
        })
      })
    },
    clearLocalForage () {
      localforage.iterate((data, key, index) => {
        if (index === 1) {
          return [key, data]
        }
      }).then((result) => {
        let data = result[1]
        let i = data.length
        while (i--) {
          let entryDate = new Date(data[i].created_at)
          let now = new Date()
          let diff = Math.abs(now - entryDate)
          let diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24))
          if (diffDays >= 3) {
            data.splice(i, 1)
          }
        }
        localforage.setItem('audits', data)
      })
    }
  },
  mounted: function () {
    this.credentials.username = this.$route.params.username
    this.credentials.password = this.$route.params.password
    this.mfa.type = this.$route.params.type === 'sms'
    if (!sessionStorage.length) {
      // Ask other tabs for session storage
      localStorage.setItem('getSessionStorage', Date.now())
    }
    if (sessionStorage.getItem('X-DOCTOR-KEY') !== null && sessionStorage.getItem('X-DOCTOR-KEY') !== '') {
      this.showAlreadyLogged = true
      this.showLogin = false
    } else {
      window.addEventListener('storage', function (event) {
        if (event.key === 'getSessionStorage') {
          // Some tab asked for the sessionStorage -> send it
          localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage))
          localStorage.removeItem('sessionStorage')
        } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
          // sessionStorage is empty -> fill it
          var data = JSON.parse(event.newValue)
          for (let key in data) { sessionStorage.setItem(key, data[key]) }
          if (sessionStorage.getItem('X-DOCTOR-KEY') !== null && sessionStorage.getItem('X-DOCTOR-KEY') !== '') {
            this.showAlreadyLogged = true
            this.showLogin = false
          } else {
            this.showAlreadyLogged = false
            this.showLogin = true
          }
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>
$danger: hsl(348, 100%, 61%);
.error-text
{
  color:$danger;
  margin-bottom:10px;
}
.title {
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/Doctor/MfaOTPConfirmationScreen.vue